var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTechOnTheWay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2354_1969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5238 3.28564H1.09521V17.5237H17.5238V3.28564Z",
    stroke: "#898A8D",
    strokeWidth: 2.30684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5239 8.76196H21.9049L25.1906 12.0477V17.5239H17.5239V8.76196Z",
    stroke: "#898A8D",
    strokeWidth: 2.30684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02374 23.0001C7.53595 23.0001 8.76184 21.7742 8.76184 20.262C8.76184 18.7498 7.53595 17.5239 6.02374 17.5239C4.51153 17.5239 3.28564 18.7498 3.28564 20.262C3.28564 21.7742 4.51153 23.0001 6.02374 23.0001Z",
    stroke: "#898A8D",
    strokeWidth: 2.30684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.262 23.0001C21.7742 23.0001 23.0001 21.7742 23.0001 20.262C23.0001 18.7498 21.7742 17.5239 20.262 17.5239C18.7498 17.5239 17.5239 18.7498 17.5239 20.262C17.5239 21.7742 18.7498 23.0001 20.262 23.0001Z",
    stroke: "#898A8D",
    strokeWidth: 2.30684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2354_1969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.2857,
    height: 26.2857,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechOnTheWay);
export default __webpack_public_path__ + "static/media/tech-on-the-way.75d42a1475d76391e095edc72878f7cb.svg";
export { ForwardRef as ReactComponent };